import React, { useState } from 'react';
import './mobile-chart-tabs.css';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ChartsPage } from '../../pages/ChartsPage';
import { useAuth } from '../../hooks/useAuth';
import { useAthleteContext } from '../../context/AthleteContext';
import { AthleteSettingsModal } from '../../components/athlete-settings/AthleteSettingsModal';

/** Mobile charts — Ai-Tempo swiper layout via ChartsPage mobile variant. */
export function MobileChartsPage() {
  const auth = useAuth();
  const { effectiveUserId, coachMenuLocked, athletes, isCoach, selectAthlete } = useAthleteContext();
  const [settingsAthleteId, setSettingsAthleteId] = useState<number | null>(null);
  const [searchParams] = useSearchParams();

  if (searchParams.get('batch') === '1') {
    return <Navigate to="/batch-compare" replace />;
  }

  if (coachMenuLocked) {
    return null;
  }

  return (
    <>
      <ChartsPage
        user={auth.user}
        effectiveUserId={effectiveUserId}
        athletes={athletes}
        onAthleteChange={isCoach ? selectAthlete : undefined}
        layout="mobile"
        initialMobileChartType={searchParams.get('chart') ?? undefined}
        onOpenAthleteSettings={(id) => setSettingsAthleteId(id)}
      />
      {settingsAthleteId != null && (
        <AthleteSettingsModal
          athleteId={settingsAthleteId}
          onClose={() => setSettingsAthleteId(null)}
          onSaved={() => void auth.refreshProfile()}
          initialView="zones-power"
        />
      )}
    </>
  );
}
